/**
 * @generated SignedSource<<1e6734a668241808375f739170863c6c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuickView_item$data = {
  readonly linkData: {
    readonly path: string | null;
  };
  readonly quickViewDisplay: {
    readonly paragraphs: ReadonlyArray<{
      readonly key: string | null;
      readonly mobileText: string | null;
      readonly text: string | null;
    } | null> | null;
    readonly " $fragmentSpreads": FragmentRefs<"QuickViewCreatorsV2_quickViewDisplay">;
  } | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"QuickViewCategory_item">;
  readonly " $fragmentType": "QuickView_item";
};
export type QuickView_item$key = {
  readonly " $data"?: QuickView_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuickView_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickView_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuickViewDisplayType",
      "kind": "LinkedField",
      "name": "quickViewDisplay",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QuickViewParagraph",
          "kind": "LinkedField",
          "name": "paragraphs",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            },
            {
              "alias": "mobileText",
              "args": [
                {
                  "kind": "Literal",
                  "name": "formatType",
                  "value": "MOBILE"
                }
              ],
              "kind": "ScalarField",
              "name": "text",
              "storageKey": "text(formatType:\"MOBILE\")"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "QuickViewCreatorsV2_quickViewDisplay"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickViewCategory_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "61c4002d9d1c9f5278f9110b2039abde";

export default node;
